import { Banknote, FileSpreadsheet, ListChecks, Wallet } from 'lucide-react';
import { LatestPayslipWidget, PayrollRunsWidget } from '@/features/payroll/dashboard-widgets';
import type { AppModule } from './registry';

/**
 * Payroll module (M6, ARCHITECTURE §8.4): shown to anyone who prepares/reads runs, disburses or
 * manages AIT; hidden from everyone else. Holding a payroll permission never adds the profile
 * Salary tab (AC-8). `/payroll` itself redirects to the first payroll page the user may open.
 */
export const payrollModule: AppModule = {
  id: 'payroll',
  label: 'Payroll',
  // Payroll run approvals open the run workspace (ADR-059, ADR-066).
  approvalLinks: { PAYROLL_RUN: (ref) => `/payroll/runs/${ref['runId'] ?? ''}` },
  nav: [
    {
      id: 'payroll-runs',
      label: 'Payroll runs',
      to: '/payroll/runs',
      icon: Banknote,
      requiredPermissions: ['payroll.read', 'payroll.disburse'],
    },
    {
      id: 'payroll-standing',
      label: 'Standing amounts',
      to: '/payroll/standing',
      icon: Wallet,
      requiredPermissions: ['payroll.prepare', 'payroll.tax.manage'],
    },
    {
      id: 'payroll-reports',
      label: 'Payroll reports',
      to: '/payroll/reports',
      icon: FileSpreadsheet,
      // The AIT statement for the tax officer; payroll sheet and PF report for readers (FR-PAY-19).
      requiredPermissions: ['payroll.read', 'payroll.tax.manage'],
    },
    {
      id: 'payroll-approvers',
      label: 'Payroll approvers',
      to: '/admin/payroll-approvers',
      icon: ListChecks,
      requiredPermissions: ['payroll.settings'],
    },
  ],
  widgets: [
    {
      // HR, approvers and Finance: what waits for approval and disbursement (T-06F).
      id: 'payroll-runs',
      title: 'Payroll runs',
      component: PayrollRunsWidget,
      requiredPermissions: ['payroll.read', 'payroll.disburse'],
    },
    {
      // Everyone: their own latest payslip (FR-PAY-18).
      id: 'latest-payslip',
      title: 'Latest payslip',
      component: LatestPayslipWidget,
    },
  ],
};
